import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=070ad6ec&scoped=true"
import script from "./progress.vue?vue&type=script&lang=js"
export * from "./progress.vue?vue&type=script&lang=js"
import style0 from "./progress.vue?vue&type=style&index=0&id=070ad6ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ad6ec",
  null
  
)

export default component.exports